module.exports = __webpack_public_path__ + "static/media/assa-logo.dde83995.svg";